export default "__VITE_ASSET__hL8DU7wJ__"